export default __webpack_public_path__ + "static/media/DoneScrum.f3853569.png";